import { WORDPRESS_API } from "shared/constants/api";

export const statutesDocuments = [
  {
    id: "ckziu",
    title: "Statut CKZiU w Wyrzysku",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Statut-CKZiU-w-Wyrzysku.pdf`
  },
  {
    id: "bsis-special",
    title: "Statut Branżowa Szkoła I Stopnia Specjalna",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Statut-Branzowa-Szkola-I-Stopnia-Specjalna.pdf`
  },
  {
    id: "bsiis",
    title: "Statut BSIIS",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Statut-BSIIS.pdf`
  },
  {
    id: "bsis",
    title: "Statut BSIS",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Statut-BSIS.pdf`
  },
  {
    id: "liceum-dla-doroslych",
    title: "Statut Liceum Ogólnokształcącego dla Dorosłych",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Statut-Liceum-Ogolnoksztalcacego-dla-Doroslych.pdf`
  },
  {
    id: "szkola-policealna",
    title: "Statut Szkoły Policealnej",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Statut-Szkoly-Policealnej.pdf`
  },
  {
    id: "technikum",
    title: "Statut Technikum",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Statut-Technikum.pdf`
  }
];